<template>
  <b-card
    title="Reaktife Giren Cihazlar"
    class="border border-secondary"
  >
    <div>

      <b-form-select
        v-model="selected"
        :options="options"
        :state="selected === null ? false : true"
      />

    </div><br>
    <b-collapse id="tik">
      <div>

        <b-form-select
          v-model="selected1"
          :options="options1"
          :state="selected1 === null ? false : true"
        />
      </div>
      <h1>ssdsdsd</h1>
    </b-collapse><br><hr style="height:2px;border-width:0;color:gray;background-color:gray">

    <reaktif /><br>
  </b-card>
</template>

<script>
import {
  BFormSelect, BCard, BCollapse, VBToggle,
} from 'bootstrap-vue'
import reaktif from './Reaktif.vue'

export default {
  components: {

    BFormSelect,
    BCard,
    BCollapse,
    reaktif,

  },
  directives: { 'b-toggle': VBToggle },

  data() {
    return {
      selected: null,
      options: [
        { value: null, text: 'Sektör Seçimi Yapınız' },
        { value: 'a', text: 'Tümü' },
        { value: 'a', text: 'A Firması' },

      ],
      selected1: null,
      options1: [
        { value: null, text: 'Kaç Adet Bağlanacak' },
        { value: 'a', text: '1' },
        { value: 'a', text: '2' },
        { value: 'a', text: '3' },
        { value: 'a', text: '4' },
        { value: 'a', text: '5' },
      ],
    }
  },
}
</script>
